import { LitElement, html, TemplateResult } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { AccordionAlign, AccordionCopyToClipboard } from '../types';
import { ButtonColor } from '../../gzIconButton/types';
import { WEB_COMPONENT_GZ_ACCORDION } from 'apps/webcomponents/src/webcomponents.constants';
import { isEmpty } from 'lodash';
import { translateFn } from '../../../utils/translator.helper';

@customElement(WEB_COMPONENT_GZ_ACCORDION)
export class GzAccordionWebComponent extends LitElement {
  @property({ type: Boolean, reflect: true })
  isCompact = false;

  @property({ type: Boolean, reflect: true })
  hasAction = false;

  @property({ type: Boolean, reflect: true })
  isOpen = false;

  @property({ type: String, attribute: true, reflect: true })
  accordionTitle = '';

  @property({ type: String, attribute: true, reflect: true })
  align: AccordionAlign = AccordionAlign.CENTER;

  @property({ type: Boolean, reflect: true, attribute: true })
  disabled = false;

  @property({ type: Boolean, attribute: true, reflect: true })
  removeTitlePadding = false;

  @property({ type: Boolean, reflect: true, attribute: true })
  nonCollapsable = false;

  @property({ type: Boolean, reflect: true, attribute: true })
  doNotShowIcon = false;

  @property({ type: Object, attribute: false, reflect: false })
  public copyToClipboard?: AccordionCopyToClipboard = {
    enabled: false,
    text: '',
  };

  @query('.gz-accordion')
  private accordion: HTMLElement;

  static get styles() {
    return styles;
  }

  render() {
    return html`
      <div class="gz-accordion" tabindex="0" part="accordionContainer">
        <div class="accordion-header" @click="${this.slideToggleAccordion}" part="accordionHeader">
          ${this.renderAction()} ${this.renderTitle()}
          <slot class="dynamic-title-content" name="dynamic-title-content"></slot>
          ${this.renderCopyToClipboardBtn()}
          ${this.doNotShowIcon
            ? ''
            : html`
                <gz-icon
                  class="dropdown-icon"
                  name="${this.nonCollapsable ? '' : 'ds-icon-arrow_down_expand'}"
                  size="24"
                  color="${ButtonColor.SECONDARY}"
                ></gz-icon>
              `}
        </div>
        <div class="accordion-content" class="active" part="accordionContent">
          <div class="slot-content" part="slotContent">
            <slot></slot>
          </div>
        </div>
      </div>
    `;
  }

  private renderTitle(): TemplateResult | undefined {
    if (isEmpty(this.accordionTitle)) {
      return;
    }

    return html`<span class="title ${this.copyToClipboard?.enabled ? 'flex-1' : ''}">${this.accordionTitle}</span>`;
  }

  private renderCopyToClipboardBtn(): TemplateResult | undefined {
    if (!this.copyToClipboard?.enabled || isEmpty(this.copyToClipboard.text)) {
      return;
    }

    return html`<gz-copy-to-clipboard
      @click="${(e: Event) => e.stopPropagation()}"
      tooltipText="${translateFn('Copy to clipboard')}"
      confirmationMessage="${translateFn('Copied')}"
      ><span class="hidden">${this.copyToClipboard.text}</span></gz-copy-to-clipboard
    >`;
  }

  public slideToggleAccordion() {
    if (this.nonCollapsable) {
      return;
    }

    this.accordion.blur();
    if (!this.disabled) {
      if (!this.isOpen) {
        this.isOpen = true;
        this.dispatchEvent(new CustomEvent('open'));
      } else {
        this.isOpen = false;
        this.dispatchEvent(new CustomEvent('close'));
      }
    }
  }

  private renderAction(): TemplateResult | undefined {
    if (this.hasAction) {
      return html`<gz-icon class="icon" name="ds-icon-drag" size="24" color="${ButtonColor.SECONDARY}"></gz-icon>`;
    }
  }
}
